import { render, staticRenderFns } from "./pushMessage.vue?vue&type=template&id=5e004e74&"
import script from "./pushMessage.vue?vue&type=script&lang=js&"
export * from "./pushMessage.vue?vue&type=script&lang=js&"
import style0 from "./pushMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports